var exports = {
  "U": "x620889e6--f21e0c--content-container",
};

module.exports = exports;
